module.exports = __webpack_public_path__ + "img/nomessage.58ee1c9c.png";